import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FilterableContainer, FilterableGrid, LinkModel, VideoPlayerCard } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-filterable-grid',
  templateUrl: './filterable-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterableGridComponent {
  @Input()
  container: FilterableGrid

  @Input()
  selectedItem: VideoPlayerCard | undefined

  @Output()
  nextPage = new EventEmitter<LinkModel>()

  public handleNextPage(link: LinkModel) {
    this.nextPage.emit(link)
  }
}
